import styled from 'styled-components';
import { Box } from '@material-ui/core';
import { Typography } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';

export const Wrapper = styled(Box)`
  ${({ theme }) => `
    // background: ${theme.palette.primary.main};
    height: ${theme.shape.topNavHeight};
    margin: ${theme.shape.layoutGap};
    // border-radius: ${theme.shape.borderRadius};
    border-bottom: 1px solid #F2F2F2;
    width: 100%;
  `}
`;

export const MobileTypography = styled(Typography)`
  font-size: 24px;
  line-height: 128.86%;
  font-weight: 600;
  color: #545454;
  font-family: 'Black Sans';
`;

export const MobileMenuContainer = styled(Box)`
  gap: 24px;
`;
export const MobileMenu = styled(Box)`
  display: flex;
  padding: 1.2rem;
  gap: 12px;
  align-items: center;
`;

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: '1em 2em',
    marginBottom: '3em',
    // border: '1px solid red'
    '& .MuiTypography-body2': {
      fontSize: '13px'
    }
  },
  brandName: {
    color: '#737373',
    fontSize: '14.22px',
    fontWeight: 700,
    fontStyle: 'normal'
  },
  menu: {
    '& .MuiGrid-item': {
      textAlign: 'center',
      '& .MuiTypography-body1': {
        fontSize: '14.22px',
        fontWeight: 400,
        fontStyle: 'normal'
      }
    }
  },
  iconRight: {
    '& .MuiGrid-item': {
      textAlign: 'center'
    },
    '& .MuiTypography-body1': {
      fontSize: '14.22px',
      color: '#545454'
    }
  },
  menuPopover: {
    paddingInline: '4px',
    '& .MuiGrid-item': {
      '& .MuiBox-root': {
        paddingBlock: '20px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: '5px',
        '&:hover': {},
        '& .active': {
          color: 'blue',
          borderRadius: '10px'
        }
      }
    }
  },
  appWrapper: {
    '&:hover': {
      // transform: 'scale(1.1)'
      background: '#E0EEF0',
      borderRadius: '10px'
    }
  },
  appMenu: {
    fontSize: '12px !important',
    lineHeight: '128.86%',
    fontWeight: 400,
    color: '#545454'
  },
  appIcon: {
    width: '40px',
    display: 'inline-block',
    backgroundColor: '#f9f9f9',
    boxShadow:
      '-6.98333px -24.4417px 23.2778px #fff, 6.98333px 24.4417px 23.2778px #e9edf2',
    '&:hover': {},
    '& img': {
      width: '100% !important'
    }
  },
  hrIcon: {
    width: '100% !important'
  },
  menuPopoverUser: {
    '& .MuiGrid-item': {
      cursor: 'pointer',
      width: '100%'
      // padding: '1em'
    },
    '& .MuiTypography-subtitle2': {
      textAlign: 'left',
      padding: '.8em 0px'
      // marginBottom: '2em'
    }
  },
  menuPopoverFooter: {
    '& .MuiGrid-item': {
      paddingTop: '1em'
    },
    '& .MuiTypography-subtitle2': {
      color: '#545454',
      fontSize: '13.61px',
      fontWeight: 400,
      fontStyle: 'normal'
    },
    '& .MuiTypography-body1': {
      color: '#545454',
      fontSize: '13.61px',
      fontWeight: 400,
      fontStyle: 'normal'
    }
  },
  test: {
    '& .MuiPopover-paper': {
      marginTop: '1.5em',
      maxWidth: '380px',
      borderRadius: '20px',
      border: '1px solid  #E1E1E1',
      background: '#FFF',
      padding: '4px 20px 20px',
      boxShadow: '1px 5px 22px 4px rgba(0, 0, 0, 0.15)',
      '& .MuiGrid-item': {
        color: '#737373'
      }
    }
  },
  dropdown: {
    '& .MuiPopover-paper': {
      width: '350px',
      marginTop: '1.8em',
      borderRadius: '20px',
      textAlign: 'center'
      // padding: '1.5em 1.2em'
      // padding: '1em'
    }
  },
  summary: {
    marginTop: '10px',
    padding: '20px',
    '& .MuiTypography-body1': {
      color: '#545454',
      fontSize: '18px',
      fontWeight: 700,
      fontStyle: 'normal'
    },
    '& .MuiTypography-subtitle2': {
      fontSize: '22px',
      fontWeight: 600,
      fontStyle: 'normal',
      textAlign: 'left',
      lineHeight: '128.86%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textTransform: 'capitalize',
      color: '#171717'
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '14px',
      fontWeight: 400,
      fontStyle: 'normal',
      textAlign: 'left',
      lineHeight: '128.86%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: '#878787'
    },
    '& .MuiAvatar-root': {
      margin: 'auto'
    }
  },
  edit: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: '#545454',
    border: '1px solid #2898A4',
    padding: '5px 20px',
    borderRadius: '18px',
    '& .MuiSvgIcon-root': {
      color: '#545454',
      fontSize: '14px',
      marginLeft: '.2em'
    }
  },
  handleViewCompany: {
    background: '#E0EEF0',
    color: '#2898A4',
    padding: '8px 20px',
    borderRadius: '34px',
    width: '75%',
    margin: '.6em auto',
    cursor: 'pointer'
  },
  small: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    border: '1px solid #e5e5e5'
  },
  medium: {
    width: 60,
    height: 60,
    margin: '0 !important',
    border: '1px solid #e5e5e5',
    borderRadius: '10px'
  },
  addBusiness: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
    padding: '1em 0px 0px',
    cursor: 'pointer',
    fontSize: '12px',
    '& .MuiSvgIcon-root': {
      fontSize: '18px'
    }
  },
  cta: {
    fontSize: '16px',
    fontWeight: 600,
    fontStyle: 'normal',
    lineHeight: '128.86%',
    color: '#545454',
    padding: '0 !important'
  },
  planWrapper: {
    background: 'white',
    width: '30%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '20px',
    textAlign: 'center',
    borderRadius: '10px',
    border: '2px solid #E1E1E1',
    boxShadow: '1px 5px 22px 4px rgba(0, 0, 0, 0.15)',
    '&:focus': {
      outline: 'none'
    },
    '& .MuiTypography-subtitle1': {
      color: '#545454',
      fontWeight: 'bold',
      fontSize: '20px',
      width: '70%',
      margin: '.3em auto',
      lineHeight: '1.4em'
    },
    '& .MuiTypography-subtitle2': {
      color: '#545454',
      fontWeight: 'normal',
      fontSize: '14px',
      margin: '.6em auto'
    },
    '& .MuiButton-contained': {
      margin: '1em 0px'
    },
    '& .trial': {
      fontSize: '14px',
      textAlign: 'center',
      // padding: '1em',
      fontWeight: 600,
      color: '#545454',
      textDecoration: 'underline',
      cursor: 'pointer'
    }
  }
}));
